import { FC } from "react";
import { IColumnProps } from "../../../interfaces/tables";
import moment from "moment";

interface DataTableProps {
    columns: IColumnProps[];
    list: any[];
    onCellClick?: (id: number, studentId: number) => void;
    onTitleClick?: (id: number, studentId: number) => void;
    isLoading?: boolean;
    titleIdentifier?: string;
    studentId?: number;
}

const DataTable: FC<DataTableProps> = (props: DataTableProps) => {
    const { list, onCellClick, onTitleClick, isLoading, columns, titleIdentifier, studentId } = props;

    const handleTitleClick = (e: React.MouseEvent, id: number, studentId: number) => {
        if (!onTitleClick) return;
        e.stopPropagation(); // Prevent row click event
        onTitleClick(id, studentId);
    };

    const handleRowClick = (id: number, studentId: number) => {
        if (!onCellClick) return;
        onCellClick(id, studentId);
    };

    const formatValue = (value: any, identifier: string) => {
        if (!value) return '-';
        if (identifier.includes('date') || identifier.includes('created_at') || identifier.includes('updated_at')) {
            return moment.utc(value).format('MMM DD, YYYY');
        }
        return value;
    };

    const renderTableBody = () => {
        if (isLoading) {
            return (
                <tr>
                    <td colSpan={columns.length}>
                        <div className="display_flex flex_dir_column display_flex_center">
                            <span className="wt_600 pb_10">Loading</span>
                            <i className='immersion__list_loader' />
                        </div>
                    </td>
                </tr>
            );
        }

        if (!list?.length) {
            return (
                <tr>
                    <td colSpan={columns.length} className='text_center'>
                        No records found.
                    </td>
                </tr>
            );
        }

        return list.map((item, index) => (
            <tr
                key={`${item.id}-${item.studentId}`}
                onClick={() => handleRowClick(item.id, item.studentId)}
                className={`immersion__student__resume__builder_row ${onCellClick ? 'cursor-pointer' : ''}`}
            >
                {columns.map((column) => {
                    const identifier = column.identifier || '';
                    const isTitle = identifier === titleIdentifier;
                    const value = column.render ? column.render(item, index) : item[identifier];
                    const formattedValue = formatValue(value, identifier);

                    return (
                        <td
                            key={identifier || column.name}
                            className={isTitle ? "immersion__student__resume__builder_primary_cell" : ""}
                        >
                            {isTitle && onTitleClick && formattedValue !== '-' ? (
                                <span
                                    className="resume-title-link cursor-pointer"
                                    onClick={(e) => handleTitleClick(e, item.id, studentId ?? 0)}
                                >
                                    {formattedValue}
                                </span>
                            ) : (
                                formattedValue
                            )}
                        </td>
                    );
                })}
            </tr>
        ));
    };

    return (
        <div className="immersion__list_table__container">
            <table className="immersion__list_table">
                <thead>
                    <tr className="text_left">
                        {columns.map((column) => (
                            <th key={column.identifier || column.name} className="immersion__student__resume__builder_column">
                                {column.name}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {renderTableBody()}
                </tbody>
            </table>
        </div>
    );
};

export default DataTable;